import { Stack, Text } from "@mantine/core";

export function ProjectExperienceInstructions() {
  return (
    <Stack gap={5}>
      <Text fw={500}>Instructions from your company</Text>
      <Text size="sm">
        List your most significant projects that best showcase your skills and
        experience relevant to the types of roles you are seeking.
      </Text>
      <Text size="sm">For each project, include:</Text>
      <Text size="sm">- Project name and brief description</Text>
      <Text size="sm">- Your role and responsibilities</Text>
      <Text size="sm">- Technologies, tools, and methodologies used</Text>
      <Text size="sm">- Significant achievements or outcomes</Text>
      <Text size="sm">
        - Time period of involvement (leave end date blank if project is
        ongoing)
      </Text>
      <Text size="sm">
        Keep descriptions concise and focused on your contributions and the
        impact you made.
      </Text>
    </Stack>
  );
}
